/** Session key for admin “act as user” studio token (separate from admin JWT). */
export const STUDIO_USER_TOKEN_KEY =
  (process.env.REACT_APP_TOKEN || "ahead_ai") + "_studio_user";

export function getStudioUserToken() {
  try {
    return sessionStorage.getItem(STUDIO_USER_TOKEN_KEY) || "";
  } catch {
    return "";
  }
}

export function setStudioUserToken(token) {
  try {
    if (token) sessionStorage.setItem(STUDIO_USER_TOKEN_KEY, token);
    else sessionStorage.removeItem(STUDIO_USER_TOKEN_KEY);
  } catch {
    /* ignore */
  }
}

export function clearStudioUserToken() {
  setStudioUserToken("");
}
